import { useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { CreditCard } from 'lucide-react';
import { TransactionTable } from '@/components/users/TransactionTable';
import { ModeFilter, AdminMode } from '@/components/ui/ModeFilter';

export const Route = createFileRoute('/_admin/transacoes')({
  component: TransacoesPage,
});

function TransacoesPage() {
  const [mode, setMode] = useState<AdminMode>('all');

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <h1 className="text-3xl font-bold flex items-center gap-2">
            <CreditCard className="h-7 w-7" />
            Transações
          </h1>
          <p className="text-muted-foreground">Gerenciamento de todas as transações da plataforma</p>
        </div>
        <ModeFilter value={mode} onChange={setMode} />
      </div>

      <TransactionTable mode={mode} />
    </div>
  );
}
